import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, computed } from 'vue';
import { format, parseISO, isValid } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePickerInput',
  props: {
    modelValue: {},
    label: {},
    rules: {},
    range: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const internalValue = ref<Date | Date[] | null>(null);

// Conversión inicial de string a Date(s)
watch(
  () => props.modelValue,
  val => {
    if (!val) {
      internalValue.value = null;
    } else if (Array.isArray(val)) {
      internalValue.value = val.map(d => parseISO(d)).filter(isValid);
    } else {
      const parsed = parseISO(val);
      internalValue.value = isValid(parsed) ? parsed : null;
    }
  },
  { immediate: true }
);


// Conversión de Date(s) a string(s)
const onDateSelected = (val: Date | Date[]) => {
  if (Array.isArray(val)) {
    const sorted = val.filter(Boolean).sort((a, b) => a.getTime() - b.getTime());
    internalValue.value = sorted;

    // Si ya hay dos fechas distintas, emitimos y cerramos
    if (sorted.length >= 2) {
      const formatted = [sorted[0].getTime(), sorted[sorted.length - 1].getTime()].map(d => format(d, 'yyyy-MM-dd')) as [string, string];
      emit('update:modelValue', formatted);
      isOpen.value = false;
    }
  } else {
    internalValue.value = val;
    emit('update:modelValue', format(val, 'yyyy-MM-dd'));
    isOpen.value = false;
  }
};


// Mostrar valor en el text-field
const displayValue = computed(() => {
  if (!internalValue.value) return '';

  const formatSafe = (d: unknown) => {
    const parsed = d instanceof Date ? d : parseISO(String(d));
    return isValid(parsed) ? format(parsed, 'yyyy-MM-dd') : '';
  };

  if (Array.isArray(internalValue.value)) {
    const [start, end] = internalValue.value;
    return `${formatSafe(start)} - ${formatSafe(end)}`;
  }

  return formatSafe(internalValue.value);
});

const clearDate = () => {
  internalValue.value = null;
  emit('update:modelValue', null);
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpen).value = $event)),
    "close-on-content-click": false,
    transition: "scale-transition",
    "offset-y": "",
    "min-width": "290px"
  }, {
    activator: _withCtx(({ props: menuProps }) => [
      _createVNode(_component_v_text_field, _mergeProps(menuProps, {
        modelValue: displayValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
        label: _ctx.label,
        readonly: true,
        clearable: true,
        rules: _ctx.rules,
        "prepend-inner-icon": "mdi-calendar",
        density: "compact",
        "onClick:clear": clearDate,
        variant: "solo-filled"
      }), null, 16, ["modelValue", "label", "rules"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_date_picker, {
        "show-adjacent-months": "",
        modelValue: internalValue.value,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((internalValue).value = $event)),
          onDateSelected
        ],
        color: "primary",
        multiple: props.range ? 'range':false
      }, null, 8, ["modelValue", "multiple"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})